import { render, staticRenderFns } from "./ImpersonateMessage.vue?vue&type=template&id=540cc672"
import script from "./ImpersonateMessage.vue?vue&type=script&lang=js"
export * from "./ImpersonateMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports